// @mui
import Container from '@mui/material/Container'

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode
}

export default function DesktopTrayMenuLayout({ children }: Props) {
  return <Container className="desktop-tray-menu-layout" sx={{ p: 0, m: 0, justifyContent: 'stretch', alignItems: 'stretch', backgroundColor: 'transparent' }}>
      {children}
  </Container>
}
